"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoreSDK = /** @class */ (function () {
    function CoreSDK() {
    }
    CoreSDK.reportEvents = function (iDTMEvent) {
        var _this = this;
        try {
            var updatedAnalyticsEvent = {
                eventAction: iDTMEvent.eventAction,
                eventCode: iDTMEvent.eventCode,
                additionaldata: iDTMEvent.additionaldata,
                datatransform: false,
                idp: true
            };
            if (typeof ddo === 'undefined') {
                // console.log(this.cachedEvents.length);
                if (this.cachedEvents.length === 0) {
                    window.addEventListener('DM_DOC_READY', function (e) {
                        for (var _i = 0, _a = _this.cachedEvents; _i < _a.length; _i++) {
                            var dtmAnalyticsEvent = _a[_i];
                            _this.pushEvent(dtmAnalyticsEvent);
                            // this.cachedEvents.shift();
                        }
                    });
                }
                this.cachedEvents.push(updatedAnalyticsEvent);
                //  console.log(this.cachedEvents.length);
            }
            else {
                this.pushEvent(updatedAnalyticsEvent);
            }
        }
        catch (e) {
            console.error('An error occurred while trying to report an event to the CORE SDK', e);
        }
    };
    CoreSDK.pushEvent = function (dtmAnalyticsEvent) {
        var appName = '';
        appName = dtmAnalyticsEvent.additionaldata['page.category.applicationName'];
        // tslint:disable-next-line:no-string-literal
        var linkDest = dtmAnalyticsEvent.additionaldata['linkDestinationUrl'];
        if (linkDest && !(linkDest.indexOf('http') > -1) && !(linkDest.indexOf('www.') > -1)) {
            // tslint:disable-next-line:no-string-literal
            dtmAnalyticsEvent.additionaldata['linkDestinationUrl'] = window && window.location && window.location.origin ? window.location.origin + linkDest : linkDest;
        }
        // fix to disable auto page load for support, upperfunnel and ise
        if (dtmAnalyticsEvent.eventCode === 'Page_Load' && appName && (appName.indexOf('eSupport') > -1)) {
            DataMappingInterface.disableAutoPageLoad();
        }
        var filterredEvent = JSON.parse(JSON.stringify(dtmAnalyticsEvent));
        DataMappingInterface.customEventNotification(filterredEvent);
    };
    CoreSDK.cachedEvents = [];
    return CoreSDK;
}());
exports.CoreSDK = CoreSDK;
//# sourceMappingURL=CoreSDK.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/core-analytics/CoreSDK.js
// module id = 1491
// module chunks = 8